










































import { Vue, Component, Prop } from 'vue-property-decorator'
import { setUserLocale } from '@/lang'
import { getModule } from 'vuex-module-decorators'
import sharedStore from '@/modules/shared/shared.store'
@Component
export default class LocaleSwitcher extends Vue {
  sharedModule = getModule(sharedStore, this.$store)

  languages = [
    { title: '繁體中文', locale: 'zh', momentLocale: 'zh-tw', country: 'tw' },
    {
      title: '简体中文',
      locale: 'zh-CN',
      momentLocale: 'zh-cn',
      country: 'cn'
    },
    /*
    { title: '日本語', locale: 'jp', country: 'jp' },
    { title: '한국어', locale: 'kr', country: 'kr' },
    */
    { title: 'English', locale: 'en', momentLocale: 'en', country: 'us' }
  ]
  @Prop({ type: String, default: '' }) classes!: string
  @Prop({ type: String, default: 'black' }) color!: string
  @Prop({ type: Boolean, default: false }) icon!: string
  @Prop({ type: Boolean, default: false }) depressed!: string
  @Prop({ type: Boolean, default: false }) hideText!: string
  @Prop({ type: String, default: '' }) text!: string

  setLocale(lang: string, momentLang: string) {
    this.$moment.locale(momentLang)
    setUserLocale(lang)

    this.sharedModule.setApplicationLocale(lang)
  }

  countryImage(country: string = 'us') {
    return require(`@/assets/country/${country}.svg`)
  }

  get selectedLocaleIndex() {
    return this.languages.findIndex(
      data => data.locale === (this.$i18n.locale || 'en')
    )
  }

  get selectedLocale() {
    return this.languages[this.selectedLocaleIndex]
  }
}
